export default __webpack_public_path__ + "static/media/kiosks.816c5ee3.svg";